import type { NextPage } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import dynamic from 'next/dynamic';
import React from 'react';

import { gasTracker } from 'nextjs/getServerSideProps';
import PageNextJs from 'nextjs/PageNextJs';

const GasTracker = dynamic(() => import('ui/pages/GasTracker'), { ssr: false });

const Page: NextPage = () => {
  return (
    <PageNextJs pathname="/gas-tracker">
      <GasTracker/>
    </PageNextJs>
  );
};

export default Page;

// export { gasTracker as getServerSideProps } from 'nextjs/getServerSideProps';

export const getServerSideProps = async(context) => {
  return {
    props: {
      ...(await serverSideTranslations(context.locale, [ 'common' ])),
      ...(await gasTracker(context)),
    },
  };
};
